import React from 'react'
import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { TrustpilotWidget } from 'components/vendor/TrustpilotWidget'
import { mediaQueriesByDevice, ROUTES } from 'parameters/index'
import Image from 'next/legacy/image'
import loansImage from '../assets/loans-explore-intro.png'
import { Box } from 'components/layout/primitives'
import { Switcher } from 'components/layout/primitives/Switcher'
import { LinkButton } from 'ui/inputs/Button/LinkButton'
import { btn } from './LoansIntroSection.css'

export const LoanIntroSection: React.FC<React.PropsWithChildren<unknown>> = () => (
	<Container>
		<Wrapper>
			<ColumnLeft>
				<h2>Quick, Easy, and 100% Free</h2>
				<StyledP>
					Just fill out our simple form and we’ll check offers from all the top providers for you in seconds.
				</StyledP>
				<Switcher>
					<LinkButton href={ROUTES.SEARCH} className={btn}>
						Start Your Search
					</LinkButton>
					<Box>
						<TrustpilotWidget widget="microStar" />
					</Box>
				</Switcher>
			</ColumnLeft>
			<Image src={loansImage} alt="" />
		</Wrapper>
	</Container>
)

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	${mediaQueriesByDevice.mobile} {
		flex-direction: column-reverse;

		h2 {
			margin-top: 40px;
		}
	}
`

const ColumnLeft = styled.div`
	padding-right: 20px;
	flex-shrink: 0;

	${mediaQueriesByDevice.mobile} {
		padding: 0;
	}
`

const StyledP = styled.p`
	margin-top: 16px;
	margin-bottom: 40px;
	max-width: 412px;

	${mediaQueriesByDevice.mobile} {
		max-width: unset;
	}
`
